import styled, { css } from 'styled-components';
import { key, palette } from 'styled-theme';

const tabletBreakpoint = key('breakpoints.tablet', '820px');
const mobileBreakpoint = key('breakpoints.mobile', '480px');

const gap = {
  medium: key('sizes.gap.normal', '16px'),
  big: key('sizes.gap.medium', '24px'),
};

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(90deg, #d3d4ff, #eceaf8);
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 1rem;
  padding: 2rem;
  max-width: 1340px;
  margin: 0 auto;
  margin-top: 75px;
`;

export const ContentBox = styled.div`
  background: white;
  border-radius: 5px;
  padding: 2rem;
  min-width: 100%;
  overflow: auto;
  border: 1px solid rgba(0, 0, 0, 0.1);
`;

export const ContentBoxRight = styled.div`
  background: white;
  border-radius: 5px;
  padding: 2rem;
  min-width: 100%;
  overflow: auto;
  border: 1px solid rgba(0, 0, 0, 0.1);
`;

export const PreContentBoxRight = styled.div`
  background: white;
  border-radius: 5px;
  padding: 2rem;
  min-width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  max-height: 54%;
  overflow-y: auto;
`;

export const LeftSection = styled.div``;

export const RightSection = styled.div`
  background: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const QuestionBox = styled.div`
  margin-bottom: 1rem;
  font-size: 16px;
  color: #333;
`;

export const TextInput = styled.textarea`
  width: 100%;
  min-height: 80px;
  padding: 1rem;
  border: 1px solid #6c75d4;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #4a90e2;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const OptionButton = styled.li`
  color: white;
  background-color: ${(props) => (props.selected ? '#639efb' : '#D7D7E2')};
  color: ${(props) => (props.selected ? '#fff' : '#000')};
  padding: 10px 20px !important;
  font-size: 14px;
  border-radius: 1.5rem;
  width: fit-content;
  cursor: pointer;
  text-align: center;
  list-style: none;
  transition:
    background-color 0.3s ease,
    box-shadow 0.3s ease;
`;

export const ContinueButton = styled.button`
  display: flex;
  align-items: center;
  justify-self: end;
  gap: 8px;
  padding: 10px 20px !important;
  font-size: 15px;
  border-radius: ${key('sizes.borderRadius.small', '10px')};
  margin-top: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: linear-gradient(90deg, #7b5cff, #60a5fa);
  color: white;
  border: none;
  text-transform: capitalize;
  font-family: ${key('fonts.primary', 'JetBrains Mono Regular')};

  &:hover {
    cursor: pointer;
    /* background: linear-gradient(90deg, #60a5fa, #7b5cff);
    transition: all 0.3s ease; */
  }
  ${({ disabled }) =>
    disabled
      ? css`
          color: gray;
          cursor: not-allowed !important;
          background: ${palette('gray', 0)} !important;
          border: none !important;
        `
      : css``}
`;

export const PropertyList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const PropertyItem = styled.div`
  border-bottom: 1px solid #eee;
  padding-bottom: 0.4rem;

  &:last-child {
    border-bottom: none;
  }
`;

export const PropertyLabel = styled.h3`
  font-size: 16px;
  margin-bottom: 0.4rem;
`;

export const PropertyValue = styled.p`
  font-size: 14px;
  color: #333;
  line-height: 1.5;
  max-height: 350px;
  overflow-y: auto;
`;

export const ErrorMessage = styled.div`
  color: #dc3545;
  padding: 1rem;
  background: #f8d7da;
  border-radius: 4px;
  margin: 1rem;
  text-align: center;
`;

export const Main = styled.main`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100vh;
  width: 100vw;

  /* Tablet + mobile: SectionRight (the map) is hidden, so the question
     content takes the full width instead of sharing the 1fr/1fr grid. */
  @media (max-width: ${tabletBreakpoint}) {
    grid-template-columns: 1fr;
    height: 100dvh;
    width: 100%;
  }
`;

export const SectionLeft = styled.section`
  background-color: ${palette('background', 0)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  overflow-y: scroll;
  ${(props) =>
    props.isEndQuestion
      ? css`
          padding: 150px 40px 40px 40px;
        `
      : css`
          padding: 80px 40px 40px 40px;
        `}

  /* Tablet + mobile: now the only column, so it takes the full grid width.
     Side padding switches to the shared gap tokens (same ones used in
     mapView.styles.js) instead of the fixed 40px desktop spacing. */
  @media (max-width: ${tabletBreakpoint}) {
    width: 100%;
    gap: ${gap.medium};
    padding: ${(props) => (props.isEndQuestion ? '96px' : '80px')} ${gap.medium} ${gap.big};
  }
`;

export const SectionRight = styled.section`
  /* background-color: #6c75d4;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 40px;
  padding: 100px 40px 40px 40px;
  overflow: hidden; */

  /* &::before {
    content: '';
    position: absolute;
    left: 5%;
    top: 10%;
    width: 40px;
    height: 100px;
    background-color: rgba(255, 255, 255, 0.2);
  }

  &::after {
    content: '';
    position: absolute;
    left: 5%;
    top: 8%;
    width: 40px;
    height: 40px;
    background-color: #45d4ff;
    transform: rotate(45deg);
  } */

  /* Tablet + mobile: map is dropped entirely so SectionLeft can take the
     full width — matches how SectionRight/the map is deprioritized on
     small screens elsewhere (see mapView.styles.js). */
  @media (max-width: ${tabletBreakpoint}) {
    display: none;
  }
`;

export const ActionLink = styled.button`
  background: none;
  border: none;
  color: blue;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
  font-weight: 500;
  font-size: inherit;
  padding: 0;
  font-family: 'JetBrains Mono Regular';

  &:hover,
  &:focus {
    color: blue;
    cursor: pointer;
  }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 1rem;
  max-height: 50%;
  @media (max-width: ${mobileBreakpoint}) {
    grid-template-columns: 1fr;
    height: 100dvh;
    width: 100%;
  }
`;

export const ProgressContainer = styled.div`
  width: 100%;
  margin-bottom: 24px;
`;

export const ProgressBarWrapper = styled.div`
  width: 100%;
  height: 8px;
  background-color: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 8px;
`;

export const ProgressBarFill = styled.div`
  height: 100%;
  background: linear-gradient(90deg, #3b82f6 0%, #2563eb 100%);
  border-radius: 4px;
  transition: width 0.3s ease;
  width: ${(props) => props.progress}%;
`;

export const ProgressInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
`;

export const ProgressText = styled.span`
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
`;

// Styled components for radio buttons
export const RadioGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin: 20px 0;
`;

export const RadioOption = styled.label`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border: 2px solid ${(props) => (props.checked ? '#3DB654' : '#e0e0e0')};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${(props) => (props.checked ? '#f0f9f4' : 'white')};

  &:hover {
    border-color: #3db654;
    background: #f0f9f4;
  }

  input[type='radio'] {
    margin-right: 12px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  span {
    font-size: 14px;
    font-weight: ${(props) => (props.checked ? '600' : '400')};
    color: ${(props) => (props.checked ? '#2c3e50' : '#4a5568')};
  }
`;

// Modal styles
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 32px;
  border-radius: 12px;
  max-width: 600px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

export const ModalTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #dc2626;
  margin: 0;
`;

export const ModalText = styled.p`
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 24px;
`;

export const ModalButton = styled.button`
  width: 100%;
  padding: 12px 24px;
  background: linear-gradient(90deg, #7b5cff, #60a5fa);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  font-family: ${key('fonts.primary', 'JetBrains Mono Regular')};
`;
